import React from 'react';
import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';

export const needsAdditionalDependentsForm = formData => {
  const relationship = formData?.claimantRelationship;
  const rawCount = formData?.dependentUnderYourCare;
  const count = Number(rawCount);

  if (!Number.isFinite(count) || count < 0) {
    return false;
  }

  const thresholds = {
    SURVIVING_SPOUSE: 2,
    CUSTODIAN_FILING_FOR_CHILD_UNDER_18: 3,
  };

  return Object.prototype.hasOwnProperty.call(thresholds, relationship)
    ? count >= thresholds[relationship]
    : false;
};

const Description = () => (
  <>
    <p>
      Since you have more than 1 additional dependent child to claim, you need
      to submit an additional form.
    </p>
    <p>You can choose any eligible child to add in the next section.</p>
    <va-alert status="warning" visible>
      <p className="vads-u-margin-top--0">
        Additional children can be added using an Application Request to Add
        and/or Remove Dependents (VA Form 21-686c).
      </p>
      <p>
        You can submit this form online, upload it at the end of this
        application, or send it to us by mail.
      </p>
      <va-link
        href="https://www.va.gov/manage-dependents/add-remove-form-21-686c-674"
        external
        text="Get VA Form 21-686c"
      />
    </va-alert>
  </>
);

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI('Additional form required'),
    'ui:description': Description,
  },
  schema: {
    type: 'object',
    properties: {},
  },
};
